import React, { Component, Fragment } from 'react';
// import Decorator from '../../../../functions/decorator';

export default class OptionSelector extends Component {
    constructor(props) {
        super(props);
        this.select = this.select.bind(this);
    }

    select() {
        this.props.select(this.props.modifierKey);
    }

    render() {
        return (
            <option value={this.props.modifierKey}>{this.props.name}</option>
        );
    }
}